import React from 'react';
import {
  Datagrid,
  FunctionField,
  Pagination,
  ReferenceManyField,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import LinkField from 'components/LinkField';
import Heading from 'components/Heading';
import IdField from 'components/IdField';
import ReviewLink from '../../reviews/ReviewLink';

const ReviewsTab = () => (
  <SimpleShowLayout>
    <Heading>Reviews by Professional</Heading>
    <ReferenceManyField
      label=""
      reference="Review"
      target="professional_reviewer_id"
      perPage={10}
      pagination={<Pagination />}
    >
      <Datagrid bulkActionButtons={false}>
        <IdField />
        <LinkField label="Job" resource="Job" source="job.id" />
        <FunctionField
          label="Reviewee"
          render={({ reviewee_type, reviewee_id }) =>
            ReviewLink({ model: reviewee_type, id: reviewee_id })
          }
        />
        <TextField label="Rating" source="rating" />
        <TextField label="Comment" source="comments" />
      </Datagrid>
    </ReferenceManyField>
    <Heading>Professional Reviews</Heading>
    <ReferenceManyField
      label=""
      reference="Review"
      target="professional_reviewee_id"
      perPage={10}
      pagination={<Pagination />}
    >
      <Datagrid bulkActionButtons={false}>
        <IdField />
        <LinkField label="Job" resource="Job" source="job.id" />
        <FunctionField
          label="Reviewee"
          render={({ reviewee_type, reviewee_id }) =>
            ReviewLink({ model: reviewee_type, id: reviewee_id })
          }
        />
        <TextField label="Rating" source="rating" />
        <TextField label="Comment" source="comments" />
      </Datagrid>
    </ReferenceManyField>
  </SimpleShowLayout>
);

export default ReviewsTab;
